import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var t = /*#__PURE__*/function () {
  function t() {
    _classCallCheck(this, t);
  }
  _createClass(t, [{
    key: "N",
    value: function N(a) {}
  }, {
    key: "changeUser",
    value: function changeUser() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    }
  }]);
  return t;
}();
export { t as default };